import React from 'react';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { DocumentStatus } from '../types';

type DocumentProgressItemProps = {
  filename: string;
  status: DocumentStatus;
};

const STATUS_MESSAGES: Partial<Record<DocumentStatus, string>> = {
  [DocumentStatus.PENDING]: 'Preparing file (1 of 2)',
  [DocumentStatus.PROCESSING]: 'Creating cards and fields (2 of 2)',
};

const DocumentProgressItem = ({
  filename,
  status,
}: DocumentProgressItemProps) => {
  const message = STATUS_MESSAGES[status];

  return (
    <div className="rounded-lg p-4 bg-gray-100">
      <div className="flex justify-between items-center">
        <div className="flex-1 text-sm text-gray-900 pr-4 break-words">
          {filename}
        </div>
        {message && (
          <div className="text-xs text-gray-500 flex-shrink-0 flex items-center gap-1.5">
            <LoadingSpinner />
            <span>{message}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentProgressItem;
